import { render, staticRenderFns } from "./page4_1.vue?vue&type=template&id=4f5d9795&scoped=true"
import script from "./page4_1.vue?vue&type=script&lang=js"
export * from "./page4_1.vue?vue&type=script&lang=js"
import style0 from "./page4_1.vue?vue&type=style&index=0&id=4f5d9795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d9795",
  null
  
)

export default component.exports